import { SANGRE } from '../ui/HudCombat.js';

/**
 * Screen flash sutil al recibir daño el player local (TKT-029).
 * Respeta accessibility "reduce motion" (skip si está activa).
 */

const FLASH_DURATION_MS = 180;

export class ScreenFlash {
  private el: HTMLElement;
  private reduceMotion = false;
  private now: () => number;

  constructor(parent: HTMLElement = document.body, now: () => number = () => performance.now()) {
    this.el = document.createElement('div');
    this.el.dataset['testid'] = 'screen-flash';
    this.el.style.cssText = `
      position: fixed; inset: 0;
      background: ${SANGRE};
      opacity: 0;
      pointer-events: none;
      transition: opacity ${FLASH_DURATION_MS}ms ease-out;
      mix-blend-mode: screen;
      z-index: 40;
    `;
    parent.appendChild(this.el);
    this.now = now;
    if (typeof window !== 'undefined' && window.matchMedia) {
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  }

  setReduceMotion(reduce: boolean): void {
    this.reduceMotion = reduce;
  }

  trigger(intensity = 0.35): void {
    if (this.reduceMotion) return;
    this.el.style.transition = 'none';
    this.el.style.opacity = String(intensity);
    void this.el.offsetHeight; // forzar reflow para que la siguiente transition aplique.
    this.el.style.transition = `opacity ${FLASH_DURATION_MS}ms ease-out`;
    this.el.style.opacity = '0';
    void this.now;
  }

  destroy(): void {
    this.el.remove();
  }
}

export { FLASH_DURATION_MS };
